import { publico } from '../../api/publico';
import { usePedido } from '../../api/usePedido';
import { Enlace, irA } from '../../router';
import { useSesion } from '../../session/Sesion';
import { Icono } from '../../ui';
import { Buscador, rutaDeBusqueda } from './Buscador';
import { InicioPaciente } from '../paciente/InicioPaciente';

const EJEMPLOS = ['me duele una muela', 'tengo un lunar que cambió', 'control del corazón'];

export function Inicio() {
  const { usuario } = useSesion();
  if (usuario?.rol === 'paciente') return <InicioPaciente />;
  return <Portada />;
}

/** La portada de MedChoice. Es a donde lleva el logo, haya sesión o no. */
export function Portada() {
  const { datos: resumen } = usePedido(() => publico.resumen(), []);
  const { datos: catalogos } = usePedido(() => publico.catalogos(), []);

  return (
    <div className="inicio">
      <section className="inicio__portada">
        <span className="eyebrow">Turnos con profesionales verificados del AMBA</span>
        <h1>Elegir bien no debería ser cuestión de suerte</h1>
        <p>Contanos qué te pasa y te mostramos quién te puede atender, con reseñas reales y horarios libres.</p>
        <Buscador tamano="grande" placeholder="Contanos qué te pasa: “me duele una muela”…"
          alBuscar={(texto) => irA(rutaDeBusqueda(texto))} />
        <div className="inicio__ejemplos">
          {EJEMPLOS.map((ejemplo) => (
            <Enlace key={ejemplo} a={rutaDeBusqueda(ejemplo)}>“{ejemplo}”</Enlace>
          ))}
        </div>
        {resumen && (
          <dl className="inicio__numeros">
            <div><dt>Profesionales verificados</dt><dd>{resumen.profesionales}</dd></div>
            <div><dt>Reseñas de pacientes</dt><dd>{resumen.resenas}</dd></div>
            <div><dt>Turnos atendidos</dt><dd>{resumen.turnos_atendidos}</dd></div>
          </dl>
        )}
      </section>

      <section className="inicio__seccion">
        <h2>Especialidades</h2>
        <div className="inicio__especialidades">
          {catalogos?.especialidades.map((especialidad) => (
            <Enlace key={especialidad} a={`/buscar?especialidad=${encodeURIComponent(especialidad)}`}>
              <Icono nombre="stethoscope" tamano={18} /> {especialidad}
            </Enlace>
          ))}
        </div>
      </section>

      <section className="inicio__seccion inicio__lados">
        <h2>Un turno tiene dos lados</h2>
        <div className="inicio__columnas">
          <article>
            <Icono nombre="user" tamano={22} />
            <h3>Si buscás atenderte</h3>
            <p>Reservás en minutos, pagás una seña si el profesional la pide y te llegan los recordatorios por WhatsApp. Si cancelás con tiempo, te devolvemos la seña.</p>
          </article>
          <article>
            <Icono nombre="stethoscope" tamano={22} />
            <h3>Si atendés pacientes</h3>
            <p>Tu agenda se llena sola, las señas bajan el ausentismo y ves en un tablero cómo va tu consultorio. Empezás gratis.</p>
            <Enlace a="/registro-profesional">Sumá tu consultorio</Enlace>
          </article>
        </div>
      </section>
    </div>
  );
}
